<template>
  <div class="container" v-if="DialogShow">
    <div class="card">
      <van-dialog v-model="DialogShow" title="添加收款" width="95%" style="height:80%" class="editClue" show-cancel-button>
        <van-form ref="form" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-collapse v-model="activeNames">
            <van-collapse-item name="0">
              <template #title>
                <span class="van-collaps-title">合同信息</span>
              </template>
              <div class="list-wrap van-hairline--top">
                <div class="item" >
                  <span class="key">合同名称：</span>
                  <span class="value">{{ contForm.contractName }}</span>
                </div>
                <div class="item" >
                  <span class="key">合同编号：</span>
                  <span class="value">{{ contForm.contractNum }}</span>
                </div>
                <div class="item" >
                  <span class="key">执行时间：</span>
                  <span class="value">{{ contForm.startTime }}至{{ contForm.endTime }}</span>
                </div>
                <div class="item" >
                  <span class="key">收款单位：</span>
                  <span class="value">{{contForm.companyName}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">垫款方式：</span>
                  <span class="value">{{formatHandel('payType',contForm.payType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">框架类型：</span>
                  <span class="value">{{formatHandel('frameType',contForm.frameType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">客户来源：</span>
                  <span class="value">{{formatHandel('custSource',contForm.custSource)}}</span>
                </div>
                <!-- <div class="item" style="width: 48%">
                  <span class="key">收款类型：</span>
                  <span class="value">{{form.incomeType == 0?'常规收款':'垫款收款'}}</span>
                </div> -->
              </div>
              <van-cell title="收款类型：">
                <template>
                  <van-radio-group v-model="form.incomeType" direction="horizontal" :disabled="contForm.creditTotalMoney<=0 || !contForm.creditTotalMoney">
                    <van-radio name="0" clickable >常规收款</van-radio>
                    <van-radio name="1" clickable >垫款收款</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <!-- <van-field readonly clickable v-model="form.contractName" @click="id?'':showContList()" label="合同名称" :rules="[{ required: true }]" placeholder="请选择合同名称" required />
              <van-field v-model="form.contractNum" label="合同编号" disabled placeholder="请先选择合同名称" />
              <van-field v-model="form.companyName" label="收款单位" disabled placeholder="请先选择合同名称" /> -->
            </van-collapse-item>
            <van-collapse-item name="1" v-if="contForm.businessTypeName?contForm.businessTypeName.indexOf('品牌推广') == -1 && contForm.businessTypeName.indexOf('数字技术') == -1:false">
              <template #title>
                <span class="van-collaps-title">合同项目</span>
              </template>
              <div class="list-wrap van-hairline--top">
                <div class="item" >
                  <span class="key">开户服务费（元）：</span>
                  <span class="value">{{contForm.openAccountFee || '-'}}</span>
                </div>
                <div class="item" >
                  <span class="key">代运营服务费：</span>
                  <span class="value">{{contForm.agentBussFee || '-'}}%</span>
                </div>
                <div class="item" >
                  <span class="key">素材费（元）：</span>
                  <span class="value">{{contForm.materialMoney || '-'}}</span>
                </div>
              </div>
              <div v-if="pointList.length == 0" style="text-align: center">暂无返点数据</div>
              <van-list :finished="finished" finished-text="没有更多了"  v-if="pointList.length > 0">
                <van-cell v-for="(item,index) in pointList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <div>
                        <span class="key"> 返点百分比值(%)：</span>
                        <span class="value">{{ item.percentage }}%</span>
                      </div>
                      <div>
                        <span class="key"> 返点消耗(元)：</span>
                        <span class="value">{{ item.useMoney }}(元)</span>
                      </div>
                      <div>
                        <span class="key"> 执行时间：</span>
                        <span class="value">{{ item.startTime }}至{{ item.endTime }}</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
            </van-collapse-item>
            <van-collapse-item title="付款信息" name="2">
              <template #title>
                <span class="van-collaps-title">付款信息</span>
              </template>
              <div class="copy"><van-button size="mini" type="info" plain native-type="button" @click="getLastRecord">点击获取</van-button>上一次付款信息的付款账号与收款银行</div>
              <van-field readonly clickable v-model="form.contPayCompanyName" @click="(id || form.contractId)?showPicker('contPayCompany'):''" label="付款单位" :rules="[{ required: true }]" placeholder="请选择付款单位" required >
                <template #button>
                  <van-button icon="plus" type="info" native-type="button" size="mini" :disabled="!id && !form.contractId" @click.stop="addPayCompany">新增</van-button>
                </template>
              </van-field>
              <template v-if="this.form.contPayCompanyName != this.contForm.custName">
                <van-cell title="当合同客户名称与选择付款单位不一致时必须上传委托付款书和原件归档日期" style="color: #ee0a24;" />
                <van-field v-model="form.saveTime" readonly clickable name="calendar" label="原件归档日期" placeholder="点击选择原件归档日期" @click="showCalendar('saveTime')" :rules="[{ required: true }]" required />
                <van-field v-model="form.agentBook" label="委托付款书" placeholder="请点击下方上传委托付款书" readonly :rules="[{ required: true }]" required />
                <van-uploader class="pictureList" v-model="agentBookList" :max-count="1" :after-read="uploadAgentBookFiles" :before-read="beforeRead" :before-delete="handleAgentBookRemove" @oversize="onOversize" :max-size="10000 * 1024" />
              </template>
              <van-field v-model="form.payBank" label="付款银行" type="text" placeholder="请输入付款银行" />
              <van-field v-model="form.payBankAccountNo" label="付款账号" type="number" placeholder="请输入付款账号" :rules="[{ required: true }]" required />
              <van-field readonly clickable v-model="form.incomeBankName" @click="showPicker('incomeBank')" label="收款银行" :rules="[{ required: true }]" placeholder="请选择收款银行" required />
              <!-- <van-field v-model="form.incomeBankNo" label="收款银行账号" type="number" placeholder="请先选择收款银行" disabled /> -->
              <van-cell title="付款状态" required>
                <template>
                  <van-radio-group v-model="form.payStatus" direction="horizontal">
                    <van-radio name="0" clickable @click="form.payStatus = '0'; form.payDate = ''">待付款</van-radio>
                    <van-radio name="1" clickable @click="form.payStatus = '1'; form.payDate = ''">已付款</van-radio>
                  </van-radio-group>
                </template>
              </van-cell>
              <van-field v-if="form.payStatus == '1'" v-model="form.payDate" readonly clickable name="calendar" label="付款日期" placeholder="点击选择付款日期" @click="showCalendar('payDate')" :rules="[{ required: true }]" required />
              <van-field v-if="form.payStatus == '0'" v-model="form.payDate" readonly clickable name="calendar" label="预计付款日期" placeholder="点击选择预计付款日期" @click="showCalendar('payDate')" :rules="[{ required: true }]" required />
              <van-field v-model="form.payMoney" label="收款金额(元)" placeholder="请输入金额" @blur="getSum('payMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
              <van-field v-model="form.payImg" label="付款截图" placeholder="请点击下方上传付款截图" :rules="form.payStatus == '1'?[{ required: true }]:[]" :required="form.payStatus == '1'?true:false" readonly />
              <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :before-delete="handleContractRemove" @oversize="onOversize" :max-size="10000 * 1024" />
              <div style="color: #ff976a;">请上传支付成功的银行回单截图（加盖银行用章）</div>
              <van-button size="mini" type="info" @click="distinguish(form.payImg)" v-if="!isClickedImg">付款流水号识别</van-button>
              <van-button size="mini" type="warning" @click="distinguish02" v-else>查看付款流水号识别</van-button>
              <div style="color: #ff976a;margin-top: 5px">温馨提示：每一笔付款截图只能使用 1 次付款流水号识别</div>
              <van-field v-model="form.serialNum" label="付款流水号" type="text" placeholder="请识别或输入流水号后面的编号" :rules="[{ required: true }]" required />
              <van-field v-model="form.remark"
                  autosize
                  label="备注"
                  placeholder="请输入备注"
                  type="textarea"
                  show-word-limit />
              <!-- <div v-for="(item,index) in authIdArr" :key="index">
                <van-field v-model="item.authId" :label="'授权账户ID(' + (index + 1) + ')'" type="number" placeholder="请输入授权账户ID" :rules="[{ required: true }]" required>
                  <template #button>
                    <van-button v-if="index == 0" icon="plus" type="info" native-type="button" size="mini" @click.stop="addAuthId">新增</van-button>
                    <van-button v-else icon="plus" color="#ee0a24" native-type="button" size="mini" @click.stop="delAuthId(index)">删除</van-button>
                  </template>
                </van-field>
              </div> -->
            </van-collapse-item>
            <van-collapse-item name="3" class="skzxkh" v-if="contForm.businessTypeName?contForm.businessTypeName.indexOf('品牌推广') == -1 && contForm.businessTypeName.indexOf('数字技术') == -1:false">
              <template #title>
                <span class="van-collaps-title">{{contForm.custSource == '2'?'收款执行明细':'收款记录明细'}}</span>
              </template>
              <van-button style="margin-top: 10px" v-if="form.flowList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+增加明细</van-button>
              <van-collapse v-model="activeNamesP">
                <van-collapse-item :title="(contForm.custSource == '2'?'执行明细':'收款明细')+(index+1)" :name="index" v-for="(item,index) in form.flowList" :key="index+'01'">
                  <van-field v-if="contForm.custSource == '2'" readonly clickable v-model="item.execCustomerName" @click="showPicker('execCustomer',index)" label="收款执行主体" placeholder="请选择收款执行主体" :rules="[{ required: true }]" required >
                    <template #button>
                      <van-button icon="plus" type="info" native-type="button" size="mini" :disabled="!id && !item.execCustomerName" @click.stop="addExecCustomer(index)">新增</van-button>
                    </template>
                  </van-field>
                  <van-field readonly clickable v-model="item.fundTypeName" @click="showPicker('fundType',index)" label="资金类型" placeholder="请选择资金类型" />
                  <van-field v-if="item.fundType == '1' || item.fundType == '2'" v-model="item.authIds" autosize label="账户ID" placeholder="填写账户ID（多个账户ID以“,“号隔开）" type="textarea" show-word-limit />
                  <van-field v-model="item.payMoney" label="金额(元)" placeholder="请输入金额" @blur="getSum('payMoney',index)" type="number" maxlength="11" :rules="[{ required: true }]" required >
                    <template slot="right-icon">￥</template>
                  </van-field>
                  <van-field v-model="item.remark" autosize label="备注" placeholder="填写备注" type="textarea" show-word-limit />
                  <div class="link">
                    <van-button class="linkaddBtn" style="width: 36%" round block type="primary" native-type="button" size="small" @click="addExecutive">+{{contForm.custSource == '2'?'增加明细':'增加资金类型'}}</van-button>
                    <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="delExecutive(index)">删除</van-button>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </van-form>
        <div class="footer">
          <van-button hairline type="defaut" plain @click="dialogCancle">取消</van-button>
          <van-button hairline type="defaut" plain @click="savePayment">保存草稿</van-button>
          <van-button hairline type="defaut" plain @click="savePayment(1)">提交</van-button>
        </div>
      </van-dialog>
      <van-calendar v-model="datePicker.showDate" :min-date="datePicker.minDate" :max-date="datePicker.maxDate" :type="datePicker.type" @confirm="dateConfirm" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
      <select-contract :show='select_show' @handleCancel='handleCancel' @beforeClose='selectBeforeClose'></select-contract>
      <van-dialog v-model="payCompanyShow" title="付款单位" width="95%" :beforeClose="payCompanyBeforeClose" show-cancel-button>
        <van-form ref="payCompanyForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field v-model="payCompanyForm.contPayCompanyName" label="付款单位" placeholder="请输入付款单位" :rules="[{ required: true }]" required />
        </van-form>
      </van-dialog>
      <!-- 付款截图识别结果 -->
      <van-dialog v-model="imageDetailVisible" title="付款流水号识别结果" width="95%" show-cancel-button confirmButtonText="付款流水号复制并关闭">
        <van-tag size="large" type='primary' v-for="(item,index) in imageDetail" :key="index" @click="clickTag(item.words)" color="#F4F5F7"
          text-color="#606060" :class="form.serialNum == item.words?'tag-click':'tag-before'">{{item.words}}</van-tag>
      </van-dialog>
      <dialog-executive :show='execCustomerShow' :isAdd="true" :contractId="id" @beforeClose='addExecutivBeforeClose'></dialog-executive>
      <!-- <van-dialog v-model="execCustomerShow" title="执行客户" width="95%" style="height:80%" class="execCustomer" :beforeClose="execCustomerBeforeClose" show-cancel-button>
        <van-form ref="execCustomerForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-collapse v-model="activeNamesE">
            <van-collapse-item name="0">
              <template #title>
                <span class="van-collaps-title">执行客户信息</span>
              </template>
              <van-field v-model="execCustomerForm.execCustomerName" label="执行客户" placeholder="请输入执行客户名称" :rules="[{ required: true }]" required />
              <van-field v-model="execCustomerForm.openAccountMoney" label="开户服务费" placeholder="请输入开户服务费"  @blur="getSum('openAccountMoney')" type="number" maxlength="11" >
                <template slot="right-icon">￥</template>
              </van-field>
              <van-field v-model="execCustomerForm.agentBusinessMoney" label="代运营服务费" placeholder="请输入代运营服务费" @blur="getSum('agentBusinessMoney')" type="number" maxlength="11" >
                <template slot="right-icon">%</template>
              </van-field>
              <van-field v-model="execCustomerForm.materialMoney" label="素材费" placeholder="请输入素材费"  @blur="getSum('materialMoney')" type="number" maxlength="11" >
                <template slot="right-icon">￥</template>
              </van-field>
            </van-collapse-item>
            <van-collapse-item name="1">
              <template #title>
                <span class="van-collaps-title">返点记录</span>
              </template>
              <van-button style="margin-top: 10px" v-if="execCustomerForm.pointList.length == 0" class="topBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点百分比</van-button>
              <van-collapse v-model="activeNamesEP">
                <van-collapse-item :title="'返点'+(index+1)" :name="index" v-for="(item,index) in execCustomerForm.pointList" :key="index+'01'">
                  <van-field v-model="item.percentage" label="返点百分比" placeholder="请输入返点百分比" type="number" >
                    <template slot="right-icon">%</template>
                  </van-field>
                  <van-field v-model="item.useMoney" label="返点消耗" :placeholder="index == 0?'无需输入,阶梯返点请增加返点':'返点消耗'" type="number" maxlength="13" @blur="fixValue(item.useMoney,index)" :disabled="index == 0">
                    <template slot="label">返点消耗<span class="dayuxiaoyufu">{{execCustomerForm.pointList.length > 1?index == 0?'<':'≥':''}}</span></template>
                    <template slot="right-icon">￥</template>
                  </van-field>
                  <van-field v-model="item.zxTime" label="执行时间" placeholder="请选择执行时间" readonly clickable @click="showCalendar('zxTime',index)" />
                  <div class="link">
                    <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addPoint">+增加返点</van-button>
                    <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deletePoint(index)">删除</van-button>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </van-collapse-item>
          </van-collapse>
        </van-form>
      </van-dialog> -->
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import payment from '@/api/cont/payment'
import newContract from '@/api/cont/newContract'
import SelectContract from '../components/SelectContract'
import { getDicts } from '@/api/system/dict/data'
import DialogExecutive from '../components/DialogExecutive.vue'

export default {
  name: 'DialogApply',
  components: {
    [Toast.name]: Toast,
    SelectContract,
    DialogExecutive
  },
  props: {
    show: Boolean,
    isAdd: Boolean,
    contractId: [Number, String],
    modifyObj: Object
  },
  watch: {
    show: {
      handler(val, oldVal) {
        this.DialogShow = val
      }
    },
    contractId: {
      immediate: true,
      handler(val, oldVal) {
        this.isClickedImg = false
        this.id = val
        payment.getIncomeType({ contractId: val }).then(res => {
          if (res.code == 200) {
            this.form.incomeType = res.data.toString()
          }
        })
        newContract.getContract(val).then(res => {
          this.contForm = res.data
          payment.listPayBank({ companyId: res.data.companyId }).then(res => {
            if (res.code === 200) {
              this.payBankList = res.rows
              const bank = this.payBankList.find(item => item.bankAccountId == this.form.incomeBankId)
              // console.log(bank)
              if (bank) { this.form.incomeBankName = `${bank.bankName}(${bank.accountNum})` }
              if (this.form.payImg) {
                this.pictureList = [{
                  url: this.form.payImg
                }]
              }
              if (this.form.agentBook) {
                this.agentBookList = [{
                  url: this.form.agentBook
                }]
              }
              if (this.isAdd) {
                const bank = this.payBankList.find(item => { return item.bankAccountId == this.contForm.bankAccountId })
                if (bank) {
                  console.log(bank)
                  this.form.incomeBankName = `${bank.bankName}(${bank.accountNum})`
                  this.form.incomeBankId = bank.bankAccountId
                  this.form.incomeBankNo = bank.accountNum
                }
              }
            }
          })
        })
        const params = {
          contractId: val
        }
        newContract.getRebateList(params).then(res => {
          this.pointList = res.rows
        })
      },
      deep: true
    },
    isAdd: {
      immediate: true,
      handler(val, oldVal) {
        this.isAdd = val
        if (val) {
          payment.listPayer({ contractId: this.id || this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
            if (response.rows.length > 0) {
              this.form.contPayCompanyName = response.rows[0].contPayCompanyName
              this.form.contPayCompanyId = response.rows[0].contPayCompanyId
            }
          })
        }
      },
      deep: true
    },
    modifyObj: {
      immediate: true,
      handler(val, oldVal) {
        if (this.isAdd) { return }
        this.form = val
        this.id = this.form.contractId
        // this.authIdArr = []
        // if (this.form.authIds) {
        //   this.form.authIds.split(',').map(item => {
        //     this.authIdArr.push({ authId: item })
        //   })
        // } else {
        //   this.authIdArr.push({ authId: '' })
        // }
        // this.$set(this.form)

        this.form.payStatus = this.form.payStatus.toString()
        payment.listExecutive({ contractId: this.id }).then(res => {
          this.executiveList = res.rows
          if (this.form.flowList) {
            this.form.flowList.forEach(res => {
              if (this.executiveList.find(item => { return item.execCustomerId == res.execCustomerId })) {
                res.execCustomerName = this.executiveList.find(item => { return item.execCustomerId == res.execCustomerId }).execCustomerName
              }
              if (this.options.fundTypeOptions.length > 0) {
                if (this.options.fundTypeOptions.find(item => { return item.dictValue == res.fundType })) {
                  res.fundTypeName = this.options.fundTypeOptions.find(item => { return item.dictValue == res.fundType }).dictLabel
                }
              }
            })
          }
        })
      }
      // deep: true
    }
  },
  data() {
    return {
      DialogShow: this.show,
      id: this.contractId,
      contForm: {},
      pointList: [],
      finished: true,
      select_show: false,
      payCompanyShow: false,
      payCompanyForm: {
        contPayCompanyName: '',
        contractId: ''
      },
      activeNames: ['0', '1', '2', '3'],
      activeNamesP: [0],
      execCustomerShow: false,
      execCustomerForm: {
        execCustomerName: null,
        pointList: [{}],
        contractId: null
      },
      activeNamesE: ['0', '1'],
      activeNamesEP: [0],
      executiveList: [],
      contractList: [],
      contPayCompanyList: [],
      payBankList: [],
      agentBookList: [],
      pictureList: [],
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      datePicker: {
        showDate: false,
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2042, 11, 31),
        type: 'single',
        formKey: ''
      },
      options: {
        // 业务类型树选项
        incomeBankOptions: [],
        contPartnerTypeOptions: [],
        fundTypeOptions: []
      },
      authIdArr: [{ authId: '' }],
      form: this.modifyObj || {
        authIds: '',
        contPayCompanyName: '',
        payBankAccountNo: '',
        incomeBankId: '',
        incomeBankName: '',
        incomeBankNo: '',
        payDate: '',
        payMoney: '',
        payImg: '',
        serialNum: '',
        remark: '',
        contractId: '',
        payStatus: '0',
        flowList: [{
          execCustomerId: null,
          execCustomerName: null,
          fundType: null,
          authIds: null,
          payMoney: null
        }],
        saveTime: null,
        agentBook: null,
        incomeType: ''
      },
      isClickedImg: false,
      imageDetail: [],
      imageDetailVisible: false
    }
  },
  async created() {
    // 框架类型
    getDicts('frame_type').then(res => {
      this.options.frameTypeOptions = res.data
    })
    // 客户来源类型
    getDicts('cust_source').then(res => {
      this.options.custSourceOptions = res.data
    })
    // 垫款方式
    getDicts('pay_type').then(res => {
      this.options.payTypeOptions = res.data
    })
    getDicts('sys_money_type').then(res => {
      this.options.fundTypeOptions = this.setDictToInt(res)
    })
    // const that = this
    if (!this.isAdd) {

    }
  },
  methods: {
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    getLastRecord() {
      payment.getDataByContractId(this.contForm.contractId).then(res => {
        if (res.code == 200) {
          if (!res.data || !res.data.payBankAccountNo || !res.data.incomeBankId) {
            Toast.fail('当前合同暂无付款信息')
          } else {
            this.form.payBankAccountNo = res.data.payBankAccountNo
            this.form.incomeBankId = res.data.incomeBankId
            const bank = this.payBankList.find(item => item.bankAccountId == this.form.incomeBankId)
            // console.log(bank)
            if (bank) { this.form.incomeBankName = `${bank.bankName}(${bank.accountNum})` }
            Toast.success('获取成功')
          }
        }
      })
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'execCustomer') {
        // if (this.executiveList.length === 0) {
        await payment.listExecutive({ contractId: this.id }).then(res => {
          this.executiveList = res.rows
        })
        // }
        this.picker.columns = this.executiveList.map((ele) => ele.execCustomerName)
        this.picker.loading = false
      } else if (type === 'contract') {
        if (this.contractList.length === 0) {
          await newContract.listPayment({ pageNum: 1, pageSize: 500, contractStatus: 6, payType: 1, orderByColumn: 'createTime', isAsc: 'desc' }).then(res => {
            this.contractList = res.rows
          })
        }
        this.picker.columns = this.contractList.map((ele) => ele.contractName)
        this.picker.loading = false
      } else if (type === 'contPayCompany') {
        // 获取付款单位信息
        // if (this.contPayCompanyList.length == 0) {
        await payment.listPayer({ contractId: this.id || this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
          this.contPayCompanyList = response.rows
        })
        // }
        this.picker.columns = this.contPayCompanyList.map((ele) => ele.contPayCompanyName)
        this.picker.loading = false
      } else if (type === 'incomeBank') {
        if (this.payBankList.length == 0) {
          await payment.listPayBank({ companyId: this.contForm.companyId }).then(res => {
            if (res.code === 200) {
              this.payBankList = res.rows
            }
          })
        }
        this.payBankList.forEach((ele) => {
          ele.incomeBankName = `${ele.bankName}(${ele.accountNum})`
        })
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'execCustomer') {
          this.form.flowList[this.index].execCustomerId = this.executiveList[key].execCustomerId
          this.form.flowList[this.index].execCustomerName = this.executiveList[key].execCustomerName
        } else {
          this.form.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form.flowList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'contract') {
          this.form.contractName = this.contractList[key].contractName
          this.form.contractId = this.contractList[key].contractId
          this.form.contractNum = this.contractList[key].contractNum
          payment.listPayer({ contractId: this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
            this.contPayCompanyList = response.rows
          })
        } else if (this.picker.formKey === 'contPayCompany') {
          this.form.contPayCompanyName = this.contPayCompanyList[key].contPayCompanyName
          this.form.contPayCompanyId = this.contPayCompanyList[key].contPayCompanyId
          if (this.form.contPayCompanyName != this.contForm.custName) {
            this.form.saveTime = null
            this.form.agentBook = null
            this.agentBookList = []
          }
        } else if (this.picker.formKey === 'incomeBank') {
          this.form.incomeBankName = this.payBankList[key].incomeBankName
          this.form.incomeBankId = this.payBankList[key].bankAccountId
          this.form.incomeBankNo = this.payBankList[key].accountNum
        }
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    showCalendar(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.datePicker.formKey = type
      if (type === 'zxTime') {
        this.datePicker.type = 'range'
      } else {
        if (this.form.payStatus == '0') {
          this.datePicker.minDate = new Date()
          this.datePicker.maxDate = new Date(2042, 11, 31)
        } else if (this.form.payStatus == '1') {
          this.datePicker.minDate = new Date(2010, 0, 1)
          this.datePicker.maxDate = new Date()
          console.log(new Date())
        } else {
          this.datePicker.minDate = new Date(2000, 0, 1)
          this.datePicker.maxDate = new Date(2042, 11, 31)
        }
        this.datePicker.type = 'single'
      }
      this.datePicker.showDate = true
    },
    dateConfirm(date) {
      if (this.index || this.index == 0) {
        if (this.datePicker.formKey === 'zxTime') {
          const [start, end] = date
          this.execCustomerForm.pointList[this.index].startTime = this.formatDate(start)
          this.execCustomerForm.pointList[this.index].endTime = this.formatDate(end)
          this.execCustomerForm.pointList[this.index].zxTime = `${this.formatDate(start)} 至 ${this.formatDate(end)}`
        }
      } else {
        // this.minDate = date
        this.form[this.datePicker.formKey] = this.formatDate(date)
      }
      this.datePicker.showDate = false
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    getSum(val, index) {
      if (index || index == 0) {
        if (val === 'advancesMoney' && this.form.contPayAgreeList[this.index][val].indexOf('.') != -1) {
          this.form.contPayAgreeList[this.index][val] = Number(this.form.contPayAgreeList[this.index][val]).toFixed(2)
        }
        if (val === 'payMoney' && this.form.flowList[index][val].indexOf('.') != -1) {
          this.form.flowList[index][val] = Number(this.form.flowList[index][val]).toFixed(2)
        }
      } else if (val === 'openAccountMoney' || val === 'agentBusinessMoney' || val === 'materialMoney') {
        if (this.execCustomerForm[val].indexOf('.') != -1) {
          this.execCustomerForm[val] = Number(this.execCustomerForm[val]).toFixed(2)
        }
      } else {
        if (this.form[val].indexOf('.') != -1) {
          this.form[val] = Number(this.form[val]).toFixed(2)
        }
        // this.amountWords = this.toChineseBig(this.form.contractMoney)
      }
    },
    addExecutive() {
      this.form.flowList.push({
        execCustomerId: null,
        execCustomerName: null,
        fundType: null,
        authIds: null,
        payMoney: null
      })
      const res = this.activeNamesP.some(item => {
        return this.form.flowList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesP.push(this.form.flowList.length - 1)
      }
    },
    delExecutive(index) {
      if (this.form.flowList.length > 0) {
        this.form.flowList.splice(index, 1)
      }
    },
    showContList() {
      this.select_show = true
    },
    handleCancel() {
      this.select_show = false
    },
    selectBeforeClose(val) {
      this.form.contractName = val.contractName
      this.form.contractId = val.contractId
      this.form.contractNum = val.contractNum
      this.form.companyName = val.companyName
      // payment.listPayer({ contractId: this.form.contractId, orderByColumn: 'createTime', isAsc: 'desc' }).then((response) => {
      //   this.contPayCompanyList = response.rows
      // })
      payment.getDataByContractId(this.form.contractId).then((response) => {
        if (response.data && response.data.authIds) {
          this.authIdArr = []
          response.data.authIds.split(',').map(item => {
            this.authIdArr.push({ authId: item })
          })
        }
        // else {
        //   this.authIdArr.push({ authId: '' })
        // }
      })
      this.select_show = false
    },
    addPayCompany() {
      this.payCompanyShow = true
      this.payCompanyForm = {
        contPayCompanyName: null,
        contractId: this.id || this.form.contractId
      }
    },
    async payCompanyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.payCompanyForm.validate()
          await payment.addPayer(this.payCompanyForm)
            .then((res) => {
              this.form.contPayCompanyId = res.data.contPayCompanyId
              this.form.contPayCompanyName = res.data.contPayCompanyName
              Toast.success('添加成功')
              setTimeout(() => {
                this.payCompanyShow = false
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.payCompanyShow = false
      }
    },
    addExecCustomer(index) {
      this.execCustomerShow = true
    },
    addExecutivBeforeClose() {
      this.execCustomerShow = false
    },
    addPoint() {
      const peo = {
        percentage: '',
        useMoney: '',
        startTime: '',
        endTime: '',
        zxTime: ''
      }
      this.execCustomerForm.pointList.push(peo)
      const res = this.activeNamesEP.some(item => {
        return this.execCustomerForm.pointList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesEP.push(this.execCustomerForm.pointList.length - 1)
      }
    },
    // deletePoint
    deletePoint(item) {
      this.execCustomerForm.pointList.splice(item, 1)
    },
    fixValue(val, index) {
      if (index == 1) {
        this.execCustomerForm.pointList[0].useMoney = val
      }
      if (Number(val) < Number(this.execCustomerForm.pointList[index - 1].useMoney)) {
        Toast.fail('当前金额不能小于上一个金额')
        this.execCustomerForm.pointList[index].useMoney = ''
      }
    },
    addAuthId() {
      const obj = { authId: '' }
      this.authIdArr.push(obj)
      // this.$set(this.authIdArr)
      console.log(this.authIdArr)
    },
    delAuthId(index) {
      this.authIdArr.splice(index, 1)
    },
    async beforeClose(type, done) {
      if (type === 'confirm') {
        this.form.authIds = []
        this.authIdArr.map(item => {
          this.form.authIds.push(item.authId)
        })
        this.form.authIds = this.form.authIds.join(',')
        if (this.isAdd) {
          if (this.id) {
            this.form.contractId = this.id
          }
          try {
            await this.$refs.form.validate()
            await payment.addFlow(this.form).then(res => {
              if (res == 200) {
                this.reset()
                Toast.success('添加成功')
                setTimeout(() => {
                  this.$emit('beforeClose', '')
                }, 500)
              } else if (res == 400) {
                Toast.fail(res.msg)
                return done(false)
              }
            }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        } else {
          try {
            await this.$refs.form.validate()
            await payment.updatePayment(this.form).then(res => {
              if (res == 200) {
                this.reset()
                Toast.success('修改成功')
                setTimeout(() => {
                  this.$emit('beforeClose', '')
                }, 500)
              } else if (res == 400) {
                Toast.fail(res.msg)
                return done(false)
              }
            }).catch(() => {})
            done()
          } catch (err) {
            return done(false)
          }
          return done(false)
        }
      } else {
        done()
        this.$emit('handleAddContractCancel')
      }
    },
    dialogCancle() {
      this.$emit('handleAddContractCancel')
    },
    async savePayment(val) {
      if (val == 1) {
        this.form.checkStatus = 1
        await this.$refs.form.validate()
      } else {
        this.form.checkStatus = 0
      }
      this.form.authIds = []
      this.authIdArr.map(item => {
        this.form.authIds.push(item.authId)
      })
      this.form.authIds = this.form.authIds.join(',')
      if (this.isAdd) {
        if (this.id) {
          this.form.contractId = this.id
        }
        await payment.addFlow(this.form).then(res => {
          if (res.code == 200) {
            this.reset()
            Toast.success('添加成功')
            setTimeout(() => {
              // this.$emit('beforeClose', '')
              if (val == 1) {
                this.$router.push({
                  path: '/cont/payment/confirmList',
                  query: {
                    status: '1'
                  }
                })
              } else {
                this.$router.push({ path: '/cont/payment/confirmList' })
              }
            }, 500)
          } else if (res.code == 400) {
            Toast.fail(res.msg)
          }
        })
      } else {
        await payment.updatePayment(this.form).then(res => {
          if (res.code == 200) {
            this.reset()
            Toast.success('修改成功')
            setTimeout(() => {
              // this.$emit('beforeClose', '')
              if (val == 1) {
                this.$router.push({
                  path: '/cont/payment/confirmList',
                  query: {
                    status: 1
                  }
                })
              } else {
                this.$router.push({ path: '/cont/payment/confirmList' })
              }
            }, 500)
          } else if (res.code == 400) {
            Toast.fail(res.msg)
          }
        })
      }
    },
    // 清空表单
    async reset() {
      this.pictureList = []
      this.agentBookList = []
      this.form = {
        contPayCompanyName: '',
        payBankAccountNo: '',
        incomeBankName: '',
        incomeBankNo: '',
        payDate: '',
        payMoney: '',
        payImg: '',
        serialNum: '',
        remark: '',
        contractId: '',
        payStatus: '0',
        flowList: [{
          execCustomerId: null,
          execCustomerName: null,
          fundType: null,
          authIds: null,
          payMoney: null
        }]
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast('文件大小不能超过 10mb')
    },
    handleAgentBookRemove(file) {
      this.form.agentBook = ''
      this.agentBookList = []
      return true
    },
    handleContractRemove(file) {
      // const picture = this.form.payImg
      // if (picture.indexOf(file.url) == 0) {
      //   if (picture.indexOf(',') == -1) {
      //     picture = null
      //   } else {
      //     picture = picture.replace(file.url + ',', '')
      //   }
      // } else {
      //   picture = picture.replace(',' + file.url, '')
      // }
      // this.form.fileList[this.index].url = picture
      // console.log(this.form.fileList[this.index].url.split(','))
      this.isClickedImg = false
      this.form.payImg = ''
      this.pictureList = []
      return true
      // if (this.form.fileList[this.index].url != '' && this.form.fileList[this.index].url != null) {
      //   const payCaptures = this.form.fileList[this.index].url.indexOf(',') > -1 ? this.form.fileList[this.index].url.split(',') : [this.form.fileList[this.index].url]
      //   payCaptures.forEach((element) => {
      //     this.form.fileList[this.index].pictureList.push({
      //       url: element
      //     })
      //   })
      // }
    },
    async uploadAgentBookFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.form.agentBook = res.url
            this.agentBookList = []
            this.agentBookList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    async uploadContractPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            // let picture = res.url
            // if (picture != null && this.form.payImg != '') {
            //   picture = res.url
            // } else {
            //   picture = res.url
            // }
            this.form.payImg = res.url
            // console.log(this.form.fileList[this.index].url)
            // console.log(this.form.fileList[this.index].url.split(','))
            // const payCaptures = picture.split(',')
            // this.form.fileList[this.index].pictureList = []
            // payCaptures.forEach((element) => {
            //   this.form.fileList[this.index].pictureList.push({
            //     url: element
            //   })
            // })
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    distinguish(image) {
      if (image) {
        payment.baiduOrc({ ocrImgUrl: image }).then(res => {
          if (res.code == 200) {
            this.isClickedImg = true
            this.imageDetail = res.data.words_result
            this.imageDetailVisible = true
          }
        })
      } else {
        Toast.fail('请先上传付款截图')
      }
    },
    distinguish02() {
      this.imageDetailVisible = true
    },
    clickTag(val) {
      this.form.serialNum = val
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  // .van-dialog__confirm{
  //   display: none;
  // }
  // .van-dialog__cancel{
  //   display: none;
  // }
  display: none;
}
.execCustomer /deep/.van-dialog__content {
  height: 80%;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 33.3%;
    border: 1px #f4f4f4 solid;
  }
}
.link{
  height: 80px;
  margin-bottom: 60px;
}
.pictureList{
  margin-left: 30px;
  margin-top: 10px;
}
.van-collaps-title{
  color: #1989fa;
}
.van-cell__value {
  min-width: 71%; //可根据自己需求设定值
  text-align: left;
}
/deep/.van-list{
  padding: 0;
  .flex-between{
    div{
      max-width: 100% !important;
    }
  }
}
.skzxkh{
  /deep/.van-collapse-item__content{
    padding: 10px;
  }
}
.copy{
  padding: 10px 0;
  display: flex;
  align-items: center;
}

.tag-click{
  border: 0.02667rem solid #1E90FF !important;
  color:#fff !important;
  background-color: #1E90FF !important;
}
.tag-before{
  border: 0.02667rem solid #999999 !important;
  background-color: #fff !important;
}
/deep/ .van-tag{
  margin: 8px 0 8px 20px;
}
</style>
